frontApp.checkLogout = {
  modal: '.js-check-logout',
  control: '.js-check-logout-btn',
  close: '.js-check-logout-close',
  isOpen: false,
  init() {
    this.events();
  },
  events() {
    const modal = document.querySelector(this.modal);
    if (!modal) {
      return false;
    }

    document.addEventListener('click', (event) => {
      const { target } = event;

      const curBtn = target.closest(this.control);
      if (!curBtn) {
        return false;
      }

      event.preventDefault();

      const href = curBtn.getAttribute('href');

      if (this.isOpen) {
        this.closeModal();
      } else {
        this.openModal(href);
      }
    });

    document.addEventListener('click', (event) => {
      const { target } = event;

      const curBtn = target.closest(this.close);
      if (!curBtn) {
        return false;
      }

      this.closeModal();
    });

    document.addEventListener('click', (e) => {
      if (
        !e.target.closest(this.modal)
        && !e.target.closest(this.control)
        && !e.target.closest('.js-search-panel')
        && !e.target.closest('.js-search-control')
        && !e.target.closest('.js-clear-scroll-locks-prevent')
      ) {
        this.closeModal();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.closeModal();
      }
    });
  },
  closeModal() {
    this.isOpen = false;

    const els = document.querySelectorAll(`${this.modal}, ${this.control}, ${this.close}`);
    els.forEach((el) => {
      el.classList.remove('is-open');
    });
  },
  openModal(id) {
    this.isOpen = true;

    if (id) {
      const target = document.getElementById(id.substring(1));

      const closeBtn = target.querySelector(`${this.close}`);
      closeBtn.classList.add('is-open');

      target.classList.add('is-open');

      return;
    }

    const els = document.querySelectorAll(`${this.modal}, ${this.control}, ${this.close}`);
    els.forEach((el) => {
      el.classList.add('is-open');
    });
  },
};
